import React from 'react';
import PropTypes from 'prop-types';

import { getPassthroughProps } from '../componentHelpers.js';
import delay from '../delay.js';
import RenderInBody from '../RenderInBody.jsx';
import window from '../window.js';
import ToolTip from './ToolTip.jsx';

let showDelay = 100;

class ToolTipRegion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickActivated: false,
      visible: false,
    };
  }

  componentWillUnmount() {
    this.removeWindowEventListeners();
  }

  addWindowEventListeners = () => {
    let parentElement = this.container.parentElement;

    while (parentElement !== null) {
      parentElement.addEventListener('scroll', this.hide);
      parentElement = parentElement.parentElement;
    }

    window.addEventListener('scroll', this.hide);
    window.addEventListener('resize', this.hide);
  }

  removeWindowEventListeners = () => {
    let parentElement = this.container.parentElement;

    while (parentElement !== null) {
      parentElement.removeEventListener('scroll', this.hide);
      parentElement = parentElement.parentElement;
    }

    window.removeEventListener('scroll', this.hide);
    window.removeEventListener('resize', this.hide);
  }

  hide = () => {
    this.setState({ clickActivated: false });
    this.setVisibility(false);
  }

  click() {
    if (!this.props.persistOnClick) {
      return;
    }

    let {
      clickActivated,
      visible
    } = this.state;

    let newClickState = !clickActivated;

    this.setState({ clickActivated: newClickState });

    if (newClickState === this.state.visible) {
      return;
    }

    this.setVisibility(newClickState);
  }

  async hover({ open }={}) {
    let { clickActivated } = this.state;
    this.clearHoverTimeout();

    if (clickActivated) {
      return;
    }

    this.hoverTimeout = delay(showDelay);
    try {
      await this.hoverTimeout;
    }
    catch (ex) {
      // delay canceled
    }
    this.setVisibility(!!open);
  }

  clearHoverTimeout() {
    if (this.hoverTimeout) {
      this.hoverTimeout.cancel();
    }
  }

  setVisibility = (visible) => {
    if (!this.state.visible && visible) {
      this.props.onShow();
    }

    if (visible) {
      this.addWindowEventListeners();
    } else {
      this.removeWindowEventListeners();
    }

    this.setState({ visible });
  }

  handleRefChanged = (container) => {
    this.container = container;
  }

  render() {
    let {
      children,
      className,
      content,
      onShow,
      style,
    } = this.props;

    return (
      <span
        tabIndex={'0'}
        onFocus={() => this.click()}
        onBlur={() => this.click()}
        style={{ display: 'inline-block', ...style }}
        className={className}
        onMouseOver={() => this.hover({ open: true })}
        onMouseOut={() => this.hover()}
        ref={this.handleRefChanged}
      >
        {children}
        {
          this.state.visible
            ?
            <RenderInBody>
              <ToolTip
                region={generateRegion(this.container)}
                {...getPassthroughProps(this)}
              >
                {content}
              </ToolTip>
            </RenderInBody>
            : null
        }
      </span>
    );
  }
}

const generateRegion = (container) => {
  if (!container) {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      height: 0,
      width: 0,
    };
  }

  let rectangle = container.getBoundingClientRect();
  return {
    top: window.pageYOffset + rectangle.top,
    right: window.pageXOffset + rectangle.right,
    bottom: window.pageYOffset + rectangle.bottom,
    left: window.pageXOffset + rectangle.left,
    height: container.clientHeight,
    width: container.clientWidth,
  };
};

ToolTipRegion.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  content: PropTypes.node,
  onShow: PropTypes.func,
  persistOnClick: PropTypes.bool,
  style: PropTypes.object,
};

ToolTipRegion.defaultProps = {
  persistOnClick: true,
  onShow: () => {},
};

export default ToolTipRegion;
